import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useSidebar } from '@/components/ui/sidebar'
import { isComplianceStudioPathname } from '@/shared/lib/isComplianceStudioPathname'

export function useAutoCollapseSidebarInComplianceStudios() {
  const { open, setOpen, setOpenMobile } = useSidebar()
  const { pathname } = useLocation()
  const wasInStudioRef = useRef(false)

  useEffect(() => {
    const inStudio = isComplianceStudioPathname(pathname)
    const enteringStudio = inStudio && !wasInStudioRef.current

    if (enteringStudio) {
      if (open) {
        setOpen(false)
      }
      setOpenMobile(false)
    }

    wasInStudioRef.current = inStudio
  }, [pathname, open, setOpen, setOpenMobile])
}
